// extracted by mini-css-extract-plugin
export default {"logo_txt":"style_logo_txt__0alqf","container":"style_container__it-pD","img":"style_img__hwZVt"};